import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Footer from "./Layout/Footer";
import Header from "./Layout/Header";
import Sidebar from "./Layout/Sidebar";
import Login from "./authentication/Login";
import Profile from "./authentication/Profile";
import Dashboard from "./dashboard/Dashboard";
import Scroll from "./Layout/Scroll";
import EmailConfiguration from "./setting/EmailConfiguration";

import ScheduleNotification from "./ScheduleNotification/ScheduleNotification";
import AddScheduleNotification from "./ScheduleNotification/AddScheduleNotification";
import EditScheduleNotification from "./ScheduleNotification/EditScheduleNotification";

import NotificationHistory from "./NotificationHistory/NotificationHistory";
import NotificationDetail from "./NotificationHistory/NotificationDetail";
import AbandonedCheckout from "./AbandonedCheckout/AbandonedCheckout";

import Customer from "./Customer/Customer";
import Product from "./Product/Product";
import ProductDetail from "./Product/ProductDetail";

function RequireAuth({ children }) {
  let accessToken = localStorage.getItem("corporateadminToken");
  if (!accessToken) {
    return <Navigate to="/" />;
  }
  return children;
}

function App() {
  let accessToken = localStorage.getItem("corporateadminToken");
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            accessToken ? <Navigate to="/dashboard" /> : <Login />
          }
        />
        {/* <Route path="/forgot-password" element={<Forgotpassword />} /> */}
        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
        <Route
          path="*"
          element={
            <RequireAuth>
              <Scroll />
              <Header />
              <div className="container-scroller">
                <div className="container-fluid page-body-wrapper">
                  <Sidebar />
                  <div className="main-panel">
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />


                      <Route path="/customers" element={<Customer />} />

                      <Route path="/products" element={<Product />} />
                      <Route path="/products/:id" element={<ProductDetail />} />
                      
                      <Route path="/schedule-notification" element={<ScheduleNotification />} />
                      <Route path="/add-schedule-notification" element={<AddScheduleNotification />} />
                      <Route path="/edit-schedule-notification/:id" element={<EditScheduleNotification />} />
                      
                      <Route path="/notification-history" element={<NotificationHistory />} />
                      <Route
                        path="/notification-history/:id"
                        element={<NotificationDetail />}
                      />
                      
                      <Route path="/abandoned-checkout" element={<AbandonedCheckout />} />

                      {/* <Route
                        path="/website-settings"
                        element={<WebsiteSettings />}
                      /> */}
                      <Route path="/my-profile" element={<Profile />} />
                      <Route
                        path="/email-configuration"
                        element={<EmailConfiguration />}
                      />
                      {/* <Route
                        path="/change-password"
                        element={<ChangePasssword />}
                      /> */}
                    </Routes>
                    <Footer />
                  </div>
                </div>
              </div>
            </RequireAuth>
          }
        />
      </Routes>
      <ToastContainer autoClose={1000} />
    </Router>
  );
}

export default App;
